module.exports = __webpack_public_path__ + "static/media/s19.fe95c269.png";